// @iconify/react axios date-fns formik yup lodash minisearch react-router-dom uuid
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore'
import {getDatabase} from 'firebase/database'
import { getAuth, onAuthStateChanged } from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5Hng82cm7Kf1DaChG7ZEe-WbpllmfpfE",
  authDomain: "build260.firebaseapp.com",
  databaseURL: "https://build260-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "build260",
  storageBucket: "build260.appspot.com",
  messagingSenderId: "283853482233",
  appId: "1:283853482233:web:5c3dfddad2bdfc97b8da28",
  measurementId: "G-VQ5G0CYQCW"
  };

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const auth = getAuth(app);
  const realdb = getDatabase(app);

  export  {db, auth, realdb, onAuthStateChanged}
 